<template>
  <div class="tagged">
    <template v-if="courses && courses.length">
      <div
        class="tagged__background"
        :style="
          `background-image: url(${$getCourseBackground(
            courses[0].objectID,
            'large'
          )}), linear-gradient(#151515, #262626);`
        "
      >
        <div class="tagged__overlay"></div>
      </div>
      <section class="tagged__wrapper">
        <h1 class="tagged__header">{{ selectionType }} Courses</h1>
        <div class="tagged__courses-wrapper">
          <CourseTile
            v-for="course in courses"
            :key="course.objectID"
            :course="course"
            :backgroundImg="$getCourseBackground(course.objectID, 'small')"
            :gradient="$getGradient()"
            :duration="$duration.getCourseDuration(course)"
            :link="$buildContentLink('course', course)"
            :customClass="'result-course'"
            :isFreeTrialUser="isFreeTrialUser"
          />
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { createIndices } from '@/services/search'
import CourseTile from '@/components/layout/CourseTile.vue'

export default {
  name: 'Tagged',
  components: {
    CourseTile,
  },
  props: {
    selectionType: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    algoliaKeys: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      courses: [],
    }
  },
  methods: {
    handleResults(index, { hits }) {
      this.courses = hits
    },
    createSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, coursesIndex: courses },
        selectionType: type,
      } = this
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'Courses',
            index: courses,
            facets: [`is_${type}`],
          },
        ],
        resultsHandler: this.handleResults,
      }
      const parentFilter = {
        facet: `is_${type}`,
        value: 'true',
      }
      createIndices(setup, parentFilter)
    },
  },
  created() {
    this.createSearchInstance()
  },
}
</script>

<style lang="scss" scoped>
.tagged {
  &__background {
    min-height: 100vh;
    width: 100%;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.7),
      var(--dark-gray),
      var(--dark-gray)
    );
    z-index: 0;
    min-height: 100vh;
    width: 100%;
  }
  &__header {
    color: var(--white);
    text-transform: capitalize;
  }
  &__wrapper {
    position: relative;
    padding: 150px 25px;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__courses-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
  }
  .result-course {
    width: 100%;
    padding: 5px;
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    @include lg-desktop {
      width: 15%;
    }
  }
}
</style>
